// extracted by mini-css-extract-plugin
module.exports = {"twins":"style_twins__3aQA1","paragraphGroup":"style_paragraphGroup__1U54h"};